import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { AuthService } from '../../../service/auth.service';
import { ResetPasswordComponent } from '../../../component/reset-password/reset-password.component';
import { MfaComponent } from '../../../component/mfa/mfa.component';
import { ChangePasswordComponent } from '../../../component/change-password/change-password.component';
import { LoginComponent } from '../../../component/login/login.component';
import { ForgotPasswordComponent } from '../../../component/forgot-password/forgot-password.component';
import { ENVIRONMENT } from '../../../../../environments/environment';
/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-alert-confirmation',
  templateUrl: './alert-confirmation.component.html',
  styleUrl: './alert-confirmation.component.scss',
  providers: [],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class AlertConfirmationComponent {
  protected authService = inject(AuthService);

  @Input() parentComponent!:
    | LoginComponent
    | ChangePasswordComponent
    | MfaComponent
    | ResetPasswordComponent
    | ForgotPasswordComponent;
  @Input() message!: string;
  @Input() optionalText?: string;

  constructor() {
    const authService = this.authService;

    this.authService = authService;
  }

  iconsStyle = ENVIRONMENT.FONTAWESOME.style;
  iconSize = 'fa-2xl';

  icons = {
    checkCircle: 'fa-circle-check',
  };
}
